import { useEffect } from "react";

/**
 * Lightweight SEO hook — sets document.title and meta description without extra lib.
 * Avoids pulling react-helmet context through the tree for a small static site.
 */
export const useSeo = ({ title, description }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
};
